(function(root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) {
    root.EnigmaEnglishOffer = api;
    var script = root.document && root.document.currentScript;
    if (script && script.hasAttribute('data-enigma-english-wishlist')) {
      api.installWishlistAjax(root.jQuery, script.getAttribute('data-enigma-english-scope'), root.location.href);
    }
  }
})(typeof window !== 'undefined' ? window : null, function() {
  'use strict';

  var sealedTypes = ['beginner box', 'booster box', 'bundle', 'collector booster box', 'commander deck'];
  var englishValues = ['en', 'eng', 'english', 'inglese'];
  function normalized(value) { return String(value == null ? '' : value).trim().toLowerCase(); }
  function isScoped(product, scopeIds) {
    if (!product || typeof product !== 'object') return false;
    var ids = Array.isArray(scopeIds) ? scopeIds.map(String) : String(scopeIds || '').split('|');
    if (ids.indexOf(String(product.id || '')) < 0) return false;
    if (sealedTypes.indexOf(normalized(product.type || product.product_type)) < 0) return false;
    var tags = (Array.isArray(product.tags) ? product.tags : String(product.tags || '').split(',')).map(normalized);
    return ['enigma-brainstorm-2026-09-07', 'magic', 'sealed'].every(function(tag) {
      return tags.indexOf(tag) >= 0;
    });
  }
  function withVariant(url, variantId) {
    var parts = String(url || '').split('#');
    var route = parts.shift().split('?');
    var query = (route[1] || '').split('&').filter(function(value) {
      return value && !/^variant=/i.test(value);
    });
    query.push('variant=' + encodeURIComponent(String(variantId)));
    return route[0] + '?' + query.join('&') + (parts.length ? '#' + parts.join('#') : '');
  }

  // Pure Ajax view model. The immutable scope IDs come from the Liquid resolver.
  // A scoped product without an explicit English offer returns null, never Italian.
  function prepare(product, scopeIds) {
    if (!isScoped(product, scopeIds)) return product;
    var options = Array.isArray(product.options) ? product.options : [];
    var languageIndex = options.findIndex(function(option) {
      var name = normalized(typeof option === 'string' ? option : option.name);
      return name === 'lingua' || name === 'language';
    });
    if (languageIndex < 0) return null;
    var variants = (Array.isArray(product.variants) ? product.variants : []).filter(function(variant) {
      var value = Array.isArray(variant.options) ? variant.options[languageIndex] : variant['option' + (languageIndex + 1)];
      return englishValues.indexOf(normalized(value)) >= 0;
    });
    if (!variants.length) return null;
    var chosen = variants.find(function(variant) { return variant.available === true; }) || variants[0];
    var ordered = [chosen].concat(variants.filter(function(variant) { return variant !== chosen; }));
    var prices = variants.map(function(variant) { return Number(variant.price); });
    if (variants.some(function(variant) { return variant.price == null; }) || prices.some(function(price) { return !Number.isFinite(price) || price < 0; })) return null;
    var result = Object.assign({}, product, {
      variants: ordered.map(function(variant) { return Object.assign({}, variant); }),
      available: variants.some(function(variant) { return variant.available === true; }),
      price: Number(chosen.price),
      price_min: Number(chosen.price),
      price_max: Number(chosen.price),
      price_varies: false,
      compare_at_price: chosen.compare_at_price,
      compare_at_price_min: chosen.compare_at_price,
      compare_at_price_max: chosen.compare_at_price,
      url: withVariant(product.url || '/products/' + product.handle, chosen.id),
      selected_variant: Object.assign({}, chosen),
      selected_or_first_available_variant: Object.assign({}, chosen),
      enigma_english_offer: true
    });
    result.options = options.map(function(option, index) {
      if (typeof option === 'string') return option;
      var values = [];
      ordered.forEach(function(variant) {
        var value = Array.isArray(variant.options) ? variant.options[index] : variant['option' + (index + 1)];
        if (values.indexOf(value) < 0) values.push(value);
      });
      return Object.assign({}, option, { values: values });
    });
    if (chosen.featured_image) {
      result.featured_image = chosen.featured_image.src || chosen.featured_image;
    }
    return result;
  }

  // jQuery.tmpl captures $data by reference; update only that transient view model.
  function prepareForTemplate(product, scopeIds) {
    var prepared = prepare(product, scopeIds);
    if (!prepared) return false;
    if (prepared !== product) Object.assign(product, prepared);
    return true;
  }

  function isWishlistRequest(url, baseUrl) {
    try {
      var base = new URL(baseUrl);
      var target = new URL(url, base);
      return target.origin === base.origin
        && /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[^/]+\.js$/i.test(target.pathname)
        && target.searchParams.get('enigma_wishlist') === '1';
    } catch (error) { return false; }
  }

  // Data conversion only: existing wishlist request, consent and storage stay owned
  // by their current bridge. Its renderer and status refinement receive one model.
  function installWishlistAjax(jquery, scopeIds, baseUrl) {
    if (!jquery || typeof jquery.ajaxPrefilter !== 'function' || jquery.__enigmaEnglishOfferWishlist) return false;
    jquery.__enigmaEnglishOfferWishlist = true;
    jquery.ajaxPrefilter('json', function(options) {
      if (!isWishlistRequest(options.url, baseUrl)) return;
      var converters = Object.assign({}, options.converters);
      var parse = typeof converters['text json'] === 'function' ? converters['text json'] : JSON.parse;
      converters['text json'] = function(value) {
        var product = parse(value);
        var prepared = prepare(product, scopeIds);
        if (!prepared) throw new Error('English offer unavailable for this wishlist product.');
        return prepared;
      };
      options.converters = converters;
    });
    return true;
  }

  return { prepare: prepare, prepareForTemplate: prepareForTemplate, installWishlistAjax: installWishlistAjax, isWishlistRequest: isWishlistRequest };
});
